import { render, staticRenderFns } from "./SynonymListSkeleton.vue?vue&type=template&id=408afeeb&"
import script from "./SynonymListSkeleton.vue?vue&type=script&lang=js&"
export * from "./SynonymListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SynonymListSkeleton.vue?vue&type=style&index=0&id=408afeeb&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408afeeb')) {
      api.createRecord('408afeeb', component.options)
    } else {
      api.reload('408afeeb', component.options)
    }
    module.hot.accept("./SynonymListSkeleton.vue?vue&type=template&id=408afeeb&", function () {
      api.rerender('408afeeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SynonymList/components/common/SynonymListSkeleton.vue"
export default component.exports